<template>
  <base-section
    id="industrial"
  >
    <!---
    <base-section-heading title="Program Committee">
    </base-section-heading>
    --->
    <v-container>
      <base-title
        title="Industrial Board"
        size="text-h4"
        class="text-center"
      />
      <base-section-heading
      divider=null
      >

      To better address the industrial necessities of ETS'23, among the committees of the conference there is also an Industrial Board composed of well-recognized Industrial professionals to guide us toward the inclusion of the most appropriate industrial content.
      </base-section-heading>
      <v-row>
        <base-avatar-card
          title="Industry Link Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(industry, i) in industries"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="industry"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <base-avatar-card
          title="Industrial Board"
          align="left"
          horizontal
        />
      <v-row>
        <v-col
          v-for="(industrial, i) in industrials"
          :key="i"
          cols="12"
          md="6"
        >
          <base-section
            space="0"
            style="text-align: left"
          >
            {{ industrial.title }} - <i>{{ industrial.text }}</i>
          </base-section>
        </v-col>
      </v-row>
      <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in committeesfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < committeesfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'industrial',
    data: () => ({
      isMobile: false,
      committeesfooter: [
        {
          name: 'Program Chair',
          url: 'program-committee',
        },
        {
          name: 'Topic Chairs',
          url: 'topic-chairs',
        },
        {
          name: 'Program Committee Members',
          url: 'members',
        },
        {
          name: 'Program Committee Companions',
          url: 'companions',
        },
        {
          name: 'Industrial Board',
          url: 'industrial',
        },
        {
          name: 'Organizing Committee',
          url: 'organizing-committee',
        },
      ],
      industries: [
        {
          title: 'Davide Appello',
          src: require('@/images/committees/davideappello.jpg'),
          text: 'STMicroelectronics, IT',
        },
        {
          title: 'Souhir Mhira',
          src: require('@/images/committees/souhir.jpg'),
          text: 'Dolphin Design, FR',
        },
      ],
      industrials: [
        /*
        {
          title: 'Riccardo Vincelli',
          text: 'Renesas',
        },
        */
        {
          title: 'Tamas Kerekes',
          text: 'NplusT',
        },
        {
          title: 'Arani Sihna',
          text: 'Intel',
        },
        {
          title: 'Matteo Coppetta',
          text: 'Infineon',
        },
        {
          title: 'Amitava Majumdar',
          text: 'AMD',
        },
        {
          title: 'Anthony Coyette',
          text: 'Onsemi',
        },
        {
          title: 'Antonio Priore',
          text: 'Qualcomm',
        },
        {
          title: 'Balwant Singh',
          text: 'STMicroelectronics',
        },
        {
          title: 'Bram Kruseman',
          text: 'NXP',
        },
        {
          title: 'Cristiano Novello',
          text: 'Indie Semiconductor',
        },
        {
          title: 'Elia Giusti',
          text: 'Microtest',
        },
        {
          title: 'Francesco Rossi',
          text: 'Resiltech',
        },
        {
          title: 'Yu Huang',
          text: 'Hisilicon',
        },
        {
          title: 'Keith Schaub',
          text: 'Advantest',
        },
        {
          title: 'Luca Di Mauro',
          text: 'ARM',
        },
        {
          title: 'Marc Hutner',
          text: 'proteanTecs',
        },
        {
          title: 'Malav Shah',
          text: 'TI',
        },
        {
          title: 'Navin Bishnoi',
          text: 'Marvell',
        },
        {
          title: 'Nilanjan Mukerjee',
          text: 'Siemens',
        },
        {
          title: 'Oscar Ballan',
          text: 'Ouster',
        },
        {
          title: 'Roger Cagliesi',
          text: 'Synegie CAD',
        },
        {
          title: 'Raffaele Vallauri',
          text: 'Technoprobe',
        },
        {
          title: 'Ric Dokken',
          text: 'Roguevation',
        },
        {
          title: 'Sandeep Goel',
          text: 'TSMC',
        },
        {
          title: 'Thomas Koehler',
          text: 'Teradyne',
        },
        {
          title: 'Vasile Toma',
          text: 'innatera',
        },
        {
          title: 'Lionel jure',
          text: 'Dolphin design',
        },
        {
          title: 'Carlo Protti',
          text: 'Allegro Microsystems',
        },
        {
          title: 'Karl Greb',
          text: 'Nvidia',
        },
        {
          title: 'Peiling Song',
          text: 'IBM',
        },
        {
          title: 'Christian Sauer',
          text: 'Cadence Design Systems',
        },
        {
          title: 'Ralf Montino',
          text: 'Elmos',
        },
        {
          title: 'Joerg Koch',
          text: 'Renesas',
        },
        {
          title: 'Luca Lillacci',
          text: 'EDA Industries',
        },
      ],
      mounted () {
        this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      methods: {
        isMobileDevice () {
          return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
        },
      },
    }),
  }
</script>
